// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3tbS9","sendOtp":"AuthorizeToLogin_sendOtp__-Nggb"};